import environment from "../../../../environments/environment";
import { axiosInterceptor } from "../authInterceptor";

const FUND_SOURCE = environment.getFundSource;
const GL_ASSETS_SUMMARY_DETAILS = environment.getGlAssetsummary;


// export async function postFundDetails(newfundData : any) {
//   try {
//     const countResponse = await axiosInterceptor.post(`${FUND_BASE_URL}funds/`, newfundData); 
//     return  countResponse
//   } catch (error: any) {
//     return error
//   }
// }


export async function getFundSource(data: any) {
  try {
    const countResponse = await axiosInterceptor.post(`${FUND_SOURCE}`, data);
    return countResponse;
  } catch (error: any) {
    console.error('getFundSource error', error);
    throw error;
  }
}

export async function getAllFundSource(participantId: string, clientId: number) {
  try {
    const response = await axiosInterceptor.get(`${GL_ASSETS_SUMMARY_DETAILS}${participantId}?clientId=${clientId}`);
    return response;
  } catch (error) {
    console.error('getAllFundSource error', error);
    throw error;
  }
}
export async function getFundTransactionDate(fundId: number, clientId: number) {
  try {
    const getResponse = await axiosInterceptor.get(`${environment.getDateForAFundTransaction}${fundId}/posting-date-lower-bound?clientId=${clientId}`);
    return getResponse;
  } catch (error: any) {
    return error;
  }
}
